<script>
    import { slide, fade } from "svelte/transition";
    import { fetchTeamMemberInvite,acceptTeamMemberInvite } from '/public/services/users/users.js';
    import { onMount } from "svelte";
    import Navbar from '/public/components/layout/Navbar.svelte';
    import PasswordComplexity from '/core/components/users/PasswordComplexity.svelte';
    import { Eye, EyeSlash } from "svelte-bootstrap-icons";

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let notFound = false;
    let inv = null;
    let first = null;
    let last = null;
    let password = null;
    let passwordStatus = 'password';
    let passwordOK = false;

    function fetchInviteInfo() {
        fetchTeamMemberInvite(hash).then(res => {
            if (res.success) {
                inv = res.data.invite;

                first = inv.first;
                last = inv.last;

                loading = false;
            } else {
                notFound = true;
                loading = false;
            }
        });
    }

    function doForm(e) {
        e.preventDefault();

        acceptTeamMemberInvite(hash, {
            first: first,
            last: last,
            password: password
        }).then(res => {
            if (res.success) {
                window.location = '/tm';
            }
        });
    }

    function togglePassword() {
        if (passwordStatus == 'password') {
            passwordStatus = 'text';
        } else {
            passwordStatus = 'password';
        }
    }

    function passwordComplexityEvent(evt) {
       
        passwordOK = evt.detail;
    }

    onMount(() => {
        fetchInviteInfo();
    });

</script>

<Navbar/>

<div class="">
    <div class='row justify-content-center mt-5'>
        <div class='col-sm-12 col-md-8 col-lg-6'>
             <div class='card shadow mt-5 mb-5 rounded-5'>
                <div class='card-body p-5'>

                    {#if loading === true}

                        <div class='mt-5 mb-5 text-center'>
                            <h4>
                                <span class='ajax-ball-loader'></span>
                            </h4>
                        </div>

                    {:else}

                        <section in:slide>

                            {#if notFound === true}

                                <div class='alert alert-info clearfix rounded shadow'>
                                    <h4 class='float-start me-2'>
                                        <span class='fas fa-info-circle'></span>
                                    </h4>
                                    Oops, we were unable to find your Invite.
                                </div>

                            {:else}

                                <h4>
                                    Lets get you setup
                                </h4>

                                <p>
                                    Invite from <span class='fw-bold'>{ inv.leader }</span> at <span class='fw-bold'>{ inv.co }</span>
                                </p>
                                <p>
                                    Sent to <span class='fw-bold'>{ inv.email }</span>
                                </p>

                                <form class='form' on:submit={doForm}>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='first'>
                                            First name
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='text'
                                                class='form-control'
                                                bind:value={first}
                                                required
                                                placeholder='What is your first name?'                                                
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='last'>
                                            Last name
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='text'
                                                class='form-control'
                                                bind:value={last}
                                                required
                                                placeholder='What is your last name?'                                                
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='last'>
                                            Password
                                        </label>
                                        <div class='col-sm-9'>
                                            <div class='input-group'>

                                                {#if passwordStatus == 'password'}

                                                    <input
                                                        type='password'
                                                        class='form-control'
                                                        bind:value={password}
                                                        minlength="8"
                                                        required                                                        
                                                    />

                                                {:else}

                                                    <input
                                                        type='text'
                                                        class='form-control'
                                                        bind:value={password}
                                                        required
                                                        minlength="8"                                                        
                                                    />

                                                {/if}

                                                <button class='btn btn-outline-secondary' type='button' on:click={togglePassword}>
                                                    
                                                    {#if passwordStatus == 'password'}

                                                        <Eye/>

                                                    {:else}

                                                        <EyeSlash/>

                                                    {/if}

                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class='text-center mb-3'>
                                        <small>

                                            {#key password}

                                                <PasswordComplexity
                                                    password={password}
                                                    on:complexity={passwordComplexityEvent}
                                                />

                                            {/key}

                                        </small>

                                    </div>

                                    {#if passwordOK === true}

                                        <div class='row mb-3' in:fade>
                                            <div class='col-sm-9 offset-sm-3'>
                                                <button type='submit' class='btn btn-primary'>
                                                    Accept Invite
                                                </button>
                                            </div>
                                        </div>

                                    {/if}

                                </form>

                            {/if}

                        </section>

                    {/if}

                </div>
             </div>
        </div>
    </div>
</div>